var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-team-container"},[_c('div',{staticClass:"team-logo"},[_c('img',{attrs:{"src":_vm.$urlOrDefault(_vm.team.logo_picture,'logo')}})]),_c('div',{staticClass:"team-name"},[_vm._v(_vm._s(_vm.teamData.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }